import { useCallback, useEffect } from 'react';
/** Simple hook to attach keydown handler to a target
 *  and calls the onUp/Down/etc handlers based on the key. */
export function useListNavigationKeys(_a) {
    var onUp = _a.onUp, onDown = _a.onDown, onHome = _a.onHome, onEnd = _a.onEnd, onEnter = _a.onEnter, onEscape = _a.onEscape, _b = _a.target, target = _b === void 0 ? document : _b;
    var keyDownHandler = useCallback(function (e) {
        switch (e.key) {
            case 'ArrowDown': {
                if (onDown) {
                    e.preventDefault();
                    onDown();
                }
                break;
            }
            case 'ArrowUp': {
                if (onUp) {
                    e.preventDefault();
                    onUp();
                }
                break;
            }
            case 'Home': {
                if (onHome) {
                    e.preventDefault();
                    onHome();
                }
                break;
            }
            case 'End': {
                if (onEnd) {
                    e.preventDefault();
                    onEnd();
                }
                break;
            }
            case 'Enter': {
                if (onEnter) {
                    e.preventDefault();
                    onEnter();
                }
                break;
            }
            case 'Escape': {
                if (onEscape) {
                    e.preventDefault();
                    onEscape();
                }
                break;
            }
        }
    }, [onDown, onUp, onHome, onEnd, onEscape, onEnter]);
    /* Attach and detach keydown & click handlers when selector is open */
    useEffect(function () {
        target.addEventListener('keydown', keyDownHandler);
        return function () {
            target.removeEventListener('keydown', keyDownHandler);
        };
    }, [keyDownHandler]);
}
//# sourceMappingURL=useListNavigationKeys.js.map